import React from 'react'
import './Stats.css'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary'
import BookIcon from '@material-ui/icons/Book'

function Stats() {
    return (
        <div className='stats'>
            <h1 style={{fontSize:"2.1rem"}}>Status</h1>
            <div className='stats-container'>
                <div className='stats-block'>
                    <LibraryBooksIcon className='stats-icon' style={{ fontSize: 80 }} />
                    <p className='stats-title'>Total Books</p>
                    <p className='stats-count'>3254</p>
                </div>
                <div className='stats-block'>
                    <LocalLibraryIcon className='stats-icon' style={{ fontSize: 80 }} />
                    <p className='stats-title'>Total Members</p>
                    <p className='stats-count'>254</p>
                </div>
                <div className='stats-block'>
                    <BookIcon className='stats-icon' style={{ fontSize: 80 }} />
                    <p className='stats-title'>Reservations</p>
                    <p className='stats-count'>54</p>
                </div>
            </div>
        </div>
    )
}

export default Stats
